
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useCiudadesStore } from "../../../../store";
import { startSavingGranja } from "../../../../services";

import Swal from "sweetalert2";




export const CreateUpdateGranja = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { startListadoCiudades, ciudades, startListadoRegiones, regiones } = useCiudadesStore();


    useEffect(() => {
        startListadoRegiones();
    }, [])



    const [formGranja, setFormGranja] = useState(initialState);
    const { nombre, metros, direccion, propietario, departamento, ciudad } = formGranja;
    const  handleInputChange = ({ target }) => {
        setFormGranja({
            ...formGranja,
            [target.name]: target.value
        });
    }


    const handleChangeRegion = async (nombre) => {
        await startListadoCiudades(nombre);
        setFormGranja(prev => ({ ...prev, departamento:nombre })); 
    };


    
    
    const crearGranja = async(e) => {
        e.preventDefault();
        if([nombre, metros, direccion, propietario, departamento, ciudad].includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }
        const result = await Swal.fire({
            title: `${(id) ? 'Actualizar' : 'Crear'} Granja`,
            text: `¿Esta seguro de ${(id) ? 'Actualizar' : 'Crear'} Granja?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Sí, ${id ? 'actualizar' : 'crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingGranja({...formGranja, id});
        if(resp){
            if(!id) { 
                setFormGranja( initialState ); 
            }else {
                queryClient.invalidateQueries({ queryKey: ['granja-id', id] });
            }
            queryClient.invalidateQueries({queryKey: ['granjas-list']});
        }
    }



    return (
        <form onSubmit={ crearGranja } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label='Nombre Granja'
                        type='text'
                        placeholder='Nombre Granja'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        label='Metros Cuadrados'
                        type='number'
                        placeholder='Metros Cuadrados'
                        fullWidth
                        name='metros'
                        value={ metros }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        label='Direccion'
                        type='text'
                        placeholder='Direccion'
                        fullWidth
                        name='direccion'
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        label='Propietario'
                        type='text'
                        placeholder='Propietario'
                        fullWidth
                        name='propietario'
                        value={ propietario }
                        onChange={ handleInputChange }
                    />
                </Grid>

                {(regiones.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='departamento'
                        value={ regiones?.find(p => p.id === departamento) || null }
                        options={ regiones || [] }
                        onChange={(_, newValue) => handleChangeRegion(newValue.id)}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Departamento' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Departamento"
                    />
                </Grid>
                }

                {(ciudades.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='ciudad'
                        value={ ciudades?.find(p => p.id === ciudad) || null }
                        options={ ciudades || [] }
                        onChange={(_, newValue) => handleInputChange({ target:{name: 'ciudad', value: newValue.id || ''}})}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Ciudad' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Ciudad"
                    />
                </Grid>
                }
                
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${id ? 'Actualizar' : 'Crear'} Granja`}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
